/* eslint-disable */
// src/components/common/Spinner.js
import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const Ring = styled.span`
  width: ${(p) => `${p.$size || 16}px`};
  height: ${(p) => `${p.$size || 16}px`};
  border-radius: 999px;
  border: 2px solid rgba(17, 24, 39, 0.18);
  border-top-color: rgba(17, 24, 39, 0.82);
  animation: ${spin} 0.9s linear infinite;
`;

export default function Spinner({ size = 16, title = "loading" }) {
    return (
        <Wrap role="status" aria-label={title}>
            <Ring $size={size} />
        </Wrap>
    );
}

/* ===========================
   FullScreenSpinner
   - visible=true 일 때만 표시
   - label/subLabel 선택
   =========================== */

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(15, 23, 42, 0.42);
  display: grid;
  place-items: center;
`;

const Panel = styled.div`
  width: min(420px, 90vw);
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(148, 163, 184, 0.35);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.28);
  padding: 18px 16px;
  display: grid;
  gap: 10px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Texts = styled.div`
  display: grid;
  gap: 4px;
`;

const Label = styled.div`
  font-size: 14px;
  color: #0f172a;
`;

const SubLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  line-height: 1.45;
`;

export function FullScreenSpinner({
    visible,
    label = "불러오는 중…",
    subLabel = "",
}) {
    if (!visible) return null;

    return (
        <Overlay>
            <Panel>
                <Row>
                    <Spinner size={18} />
                    <Texts>
                        <Label>{label}</Label>
                        {subLabel ? <SubLabel>{subLabel}</SubLabel> : null}
                    </Texts>
                </Row>
            </Panel>
        </Overlay>
    );
}
